import { EventCardLogsQuery, GoalCardLogsQuery } from '../api/log/log.queries';
import { isGoalCardId } from './typename.utils';

export function getLogRefetchQueries(cardId: string) {
  const isGoalCard = isGoalCardId(cardId);

  const logRefetchQueries = isGoalCard
    ? [
        {
          query: GoalCardLogsQuery,
          variables: {
            goalCardIds: [cardId],
          },
        },
      ]
    : [
        {
          query: EventCardLogsQuery,
          variables: {
            eventCardIds: [cardId],
          },
        },
      ];
  return logRefetchQueries;
}
